import React from 'react';

import { SelectCurrency } from '@/features/select-currency/ui/select-currency';
import { CloseIconImage } from '@/features/auth-managment/styles';

import { Box } from '@/shared/ui/box';
import { formatCurrency } from '@/shared/libs/format-currency';
import { BoldHeadingTertiary } from '@/shared/ui/typography';

import { BlockCurrency } from './style';

export const WalletHeader = ({ onClose, balance, user }) => (
  <>
    <Box onClick={onClose}>
      <CloseIconImage
        width={32}
        height={32}
        src="/images/icons/close-dialog.svg"
      />
    </Box>
    <BlockCurrency>
      <BoldHeadingTertiary>
        {formatCurrency(balance, {
          currency: user.currency,
          currencySymbol: user.currencySymbol,
        })}
      </BoldHeadingTertiary>
      <Box>
        <SelectCurrency />
      </Box>
    </BlockCurrency>
  </>
);
